<template>
    <div class="feedback p-4">
        
        <div v-if="!filteredIssues.length">
            <p class="text-center">{{ $t('issues.no-issue') }}</p>
        </div>
        
        <div v-else class="timeline timeline-one-side" data-timeline-content="axis" data-timeline-axis-style="dashed">
            <div v-for="(item, index) in filteredIssues" :key="index">
                <div class="timeline-block"
                    :class="{'timeslot-block': !item.author_role, 'issue-block': item.author_role}">

                    <span class="timeline-step badge-default">
                        <i class="fas fa-thumbtack"></i>
                    </span>
                    
                    <div class="timeline-content">

                        <issue v-if="item.author_role"
                            :issue="item"
                            :lang="registration.degree.lang"
                            @remove="remove"
                            @save="save"
                        >
                        </issue>

                        <timeslot-issues v-if="!item.author_role"
                            :timeslot="item"
                            :lang="registration.degree.lang"
                            @remove="remove" 
                            @save="save"
                        >
                        </timeslot-issues>
                    </div>
                </div>
            </div>
        </div>

        <portal to="modals">

            <confirm-modal v-model="modals.confirmDelete">
                <p>{{ $t('issues.delete-confirm') }}</p>
            </confirm-modal>

        </portal>

    </div>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'
    import CrudClient from '@trax/classes/CrudClient'
    import Issue from './Issue'
    import TimeslotIssues from './TimeslotIssues'
    import moment from 'moment'

    export default {

        components: {
            Issue, TimeslotIssues
        },

        props: {
            
            registration: {
                type: Object,
                required: true
            },
            
            simulation: {
                type: Object,
                required: true
            },

            role: {
                type: String,
                default: null
            },
        },

        data() {
            const context = this.role == 'instructor' ? 'session' : 'log'
            let endpoint = '/socrates/api/front/dashboard/data/context/' + context + '/issues'
            
            let client = new CrudClient(endpoint, {
                registration_id: this.registration.id,
                simulation_id: this.simulation.id,
                session_id: null,
                role: this.role,
                scope: 'all',
            })
            return {
                endpoint,
                client,
                modals: new ModalsController(['confirmDelete']),
                issues: [],
                moment: moment,
            }
        },

        created() {
            this.modals.init(this, 'modals')
            this.list()
        },

        computed: {

            filteredIssues() {
                return this.issues.filter(item => item.author_role || (item.issues && item.issues.length))
            },
        },

        methods: {

            list() {
                this.client.list().then(resp => {          
                    this.issues = resp.data.data
                })
            },

            remove(issue) {
                this.modals.open('confirmDelete').then(resp => {
                    if (resp.confirmed) {
                        this.client.delete(issue.id).then(resp => {
                            this.list()
                        })
                    }
                })
            },

            save(issue) {
                this.client.update(issue).then(resp => {
                    this.list()
                })
            },
        }
    }
</script>

<style scoped>

    .description {
        white-space: pre-wrap;
    }
    @media (min-width: 992px) {
        .timeline-one-side .timeline-content {
            max-width: none;
        }
    }
    .timeslot-block {
        margin-bottom: 0;
    }
    .issue-block {
        margin-bottom: 20px;
    }

</style>
